import WebSDK from "@yo-star/websdk"

import configJson from "../../config/SDKConfigSettings.json"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const websdk = new WebSDK(configJson as any)
websdk.Init({ PID: configJson.Regions.Kr.Sdk_Pid })
